import { MedfarDictionariesValidationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/MedfarDictionariesValidationRule";
import { IPharmacyInfo } from "@/Common/Api/Pharmacy/Dto/Responses/IPharmacyInfo";
import { PhoneNumberHelper } from "@/ContactDirectory/Helpers/PhoneNumberHelper";
import { PreferredPharmacyHelper } from "../Helpers/PreferredPharmacyHelper";
import { PharmacyProxy } from "../Models/PharmacyProxy";

type PreferredPharmacyField = "Banner" | "Pharmacists" | "Phone" | "Fax" | "Address";

export class PreferredPharmacyValidator {
    private helper: PreferredPharmacyHelper;

    public constructor(helper: PreferredPharmacyHelper) {
        this.helper = helper;
    }

    public validate(model: PharmacyProxy): boolean {
        const directoryPharmacy = model?.getDirectoryPharmacy();
        return this.validateInfo(model?.getPharmacyInfo(false), directoryPharmacy?.address?.countryId, directoryPharmacy?.address?.stateId);
    }

    public validateInfo(pharmacyInfo: IPharmacyInfo, countryId?: string, stateId?: string): boolean {
        if (!cacheStore.ClinicSettings.EnableContactDirectory || this.areFieldsEmpty(pharmacyInfo))
            return true;

        const { country, state } = this.helper.getCountryAndState(countryId, stateId);
        const isValid = !IsNullOrWhiteSpace(pharmacyInfo.Banner) && PhoneNumberHelper.validate(pharmacyInfo.Fax, country?.Id, state?.Id);

        return country?.Alpha2Code === "CA" && state?.SubdivisionCode === "CA-QC"
            ? isValid && !IsNullOrWhiteSpace(pharmacyInfo.Name) // pharmacists (Name) is required for Quebec
            : isValid;
    }

    public validateField(field: PreferredPharmacyField, value: string, countryId?: string, stateId?: string): boolean {
        if (!cacheStore.ClinicSettings.EnableContactDirectory)
            return true;

        const { country, state } = this.helper.getCountryAndState(countryId, stateId);

        switch (field) {
            case "Banner":
                return !IsNullOrWhiteSpace(value);
            case "Pharmacists":
                return country?.Alpha2Code === "CA" && state?.SubdivisionCode === "CA-QC"
                    ? !IsNullOrWhiteSpace(value)
                    : true;
            case "Phone":
            case "Fax":
                return PhoneNumberHelper.validate(value, country?.Id, state?.Id);
            case "Address":
                return !IsNullOrWhiteSpace(value);
            default:
                return true;
        }
    }

    public getPhoneValidationRule(): MedfarDictionariesValidationRule {
        const { country, state } = this.helper.getCountryAndState();
        return PhoneNumberHelper.getValidationRule(country?.Id, state?.Id);
    }

    private areFieldsEmpty(pharmacyInfo: IPharmacyInfo): boolean {
        return !pharmacyInfo
            || (
                IsNullOrWhiteSpace(pharmacyInfo.Banner)
                && IsNullOrWhiteSpace(pharmacyInfo.Name)
                && IsNullOrWhiteSpace(pharmacyInfo.Phone)
                && IsNullOrWhiteSpace(pharmacyInfo.Fax)
                && IsNullOrWhiteSpace(pharmacyInfo.Address)
            );
    }
}
